import React from 'react';
import { motion } from 'framer-motion';

export const EndNote = ({ active }) => (
  <div className="flex flex-col items-center px-6 text-center" data-testid="end-note">
    <motion.span
      initial={{ opacity: 0 }}
      animate={active ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 1.6, ease: 'easeOut' }}
      className="mb-8 h-px w-10 bg-ember/60"
    />
    <motion.p
      initial={{ opacity: 0 }}
      animate={active ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 2.4, ease: 'easeOut', delay: 0.4 }}
      className="font-serif italic text-2xl sm:text-3xl text-cream/85"
    >
      You’ve reached the end. For now.
    </motion.p>
  </div>
);
